import LegalPage from "@/components/legal/LegalPage";

const Cookies = () => <LegalPage slug="cookies" />;

export default Cookies;
